import { Font } from '@react-pdf/renderer';
import { Buffer } from 'buffer';

// 1. Buffer polyfill bootstrapping
if (typeof window !== 'undefined' && !(window as any).Buffer) {
  (window as any).Buffer = Buffer;
}

// 2. Roboto Font Registration (Standardized)
let fontsRegistered = false;
export const registerReportFonts = () => {
  if (fontsRegistered) return;
  fontsRegistered = true;
  try {
    Font.register({
      family: 'Roboto',
      src: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Regular.ttf',
    });

    Font.register({
      family: 'Roboto',
      src: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Medium.ttf',
      fontWeight: 'bold',
    });

    Font.register({
      family: 'Roboto',
      src: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.12/fonts/Roboto/Roboto-Italic.ttf',
      fontStyle: 'italic',
    });
  } catch (error) {
    console.error('Error registering fonts:', error);
  }
};

// 3. Disclaimer Content Processor
export const processDisclaimerContent = (content: string) => {
  if (!content) return [];
  let processed = content
    .replace(/\\n/g, '\n')
    .replace(/\\s+/g, ' ')
    .replace(/<p[^>]*>/gi, '')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<br\s*\/?/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
  const sentences = processed.split(/\.\s+/).map(s => s.trim()).filter(s => s.length > 0);
  let paragraphs: string[] = [];
  let currentParagraph = '';
  for (let i = 0; i < sentences.length; i++) {
    const sentence = sentences[i];
    currentParagraph += sentence + '. ';
    if (sentence.includes('prior consent') ||
      sentence.includes('definitive risk analysis') ||
      sentence.includes('general public') ||
      i === sentences.length - 1) {
      paragraphs.push(currentParagraph.trim());
      currentParagraph = '';
    }
  }
  if (paragraphs.length !== 3) {
    const text = processed;
    const p1End = text.indexOf('prior consent.') + 'prior consent.'.length;
    const p2End = text.indexOf('definitive risk analysis.') + 'definitive risk analysis.'.length;
    if (p1End > 0 && p2End > p1End) {
      paragraphs = [
        text.substring(0, p1End).trim(),
        text.substring(p1End, p2End).trim(),
        text.substring(p2End).trim()
      ];
    }
  }
  return paragraphs;
};

// 4. Stable Severity Ordering Sort Comparator
export const severityOrder: Record<string, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
  info: 4,
  none: 4
};

export const sortFindings = (findings: any[]) => {
  return [...findings].sort((a, b) => {
    const aSev = (a.severity_category || 'info').toLowerCase();
    const bSev = (b.severity_category || 'info').toLowerCase();
    if (severityOrder[aSev] !== severityOrder[bSev]) {
      return (severityOrder[aSev] ?? 99) - (severityOrder[bSev] ?? 99);
    }
    const dateA = new Date(a.submitted_date || 0).getTime();
    const dateB = new Date(b.submitted_date || 0).getTime();
    if (dateA !== dateB) return dateA - dateB;
    return (a.report_id || 0) - (b.report_id || 0);
  });
};
